export const validateVendorForm = ({name, phone}: {name: string, phone:string})=> {
  console.log(phone)
    const errors = {
       name: '',
       phone: '',
      
     
     };
     if (!name) {
       errors.name = 'Name is required';
      
     }
    //  if (!email) {
    //    errors.email = 'Email is required';
     
    //  } else if (!/\S+@\S+\.\S+/.test(email)) {
    //    errors.email = 'Email is invalid';
      
    //  }
     if (!phone) {
       errors.phone = 'Phone is required';
     
     }
    
    // Check if any error messages are present
    const hasErrors = Object.values(errors).some(error => error !== '');
   
   
   
   
   return { hasErrors, errors };
   };
   